module.exports = __webpack_public_path__ + "img/2.dfe01caa.png";